<div class="legal-container">
  <p class="copyright">©</p>
  <p>{{ now | date: 'yyyy' }} SaniUp GmbH</p>
  <p><a [routerLink]="[]" (click)="openLegalDialog()">Rechtliche Hinweise</a></p>
</div>
